/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CookieNotification_viewer = {
    readonly gdprDisplayInfo: {
        readonly isGdprApplicable: boolean | null;
        readonly cookieNotificationMessage: string | null;
    } | null;
    readonly " $refType": "CookieNotification_viewer";
};
export type CookieNotification_viewer$data = CookieNotification_viewer;
export type CookieNotification_viewer$key = {
    readonly " $data"?: CookieNotification_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CookieNotification_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CookieNotification_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "gdprDisplayInfo",
      "kind": "LinkedField",
      "name": "gdprDisplayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            }
          ],
          "kind": "ScalarField",
          "name": "isGdprApplicable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cookieNotificationMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '19f09c01096af8b3c03e92f1c37fc4b7';
export default node;
